import Chip from '@material-ui/core/Chip';
import CloseIcon from '@material-ui/icons/Close';
import classnames from 'classnames';
import { any, arrayOf, bool, func, number, shape, string } from 'prop-types';
import React, { cloneElement, Component, Fragment } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { validateEmailInfo } from '../../helpers/validate';
import { CHARACTER_LIMIT, EMAIL_LIMIT, INPUT_ERROR_MESSAGE } from './helpers';
import styles from './styles.scss';
import AgentButtons from '../AgentButtons';
import {marked} from 'marked';
import { fetchAgentTemplate } from '../../helpers/agentAPI';
import { showToast } from '../../state/modules/app/notification';
import { connect } from 'react-redux';
import { compose } from 'redux';
class InvitationForm extends Component {
  static propTypes = {
    baseUrl: string.isRequired,
    edit: bool,
    disabled: bool,
    emailLimit: number,
    emailInputLabel: string,
    messageInputLabel: string,
    processingMessage: string,
    connectAgentMessageButton: string,
    revertStandardInstructions: string,
    useAgentSuggestion: string,
    messageCharacterLimit: number,
    onEmailInfoChange: func,
    classes: shape({ any }),
    emailInfo: shape({
      emails: arrayOf(string),
      emailError: string,
      emailValue: string,
      message: string,
      msgError: string,
    }),
    helperText: string,
    title: string,
    selectedConnectionType: string,
    advertiserUrl: string,
    validateOnChange: bool,
    isDisabled: bool,
    dispatch: func.isRequired,
    showToast: func.isRequired,
  };

  static defaultProps = {
    emailInputLabel: 'To',
    messageInputLabel: 'Message',
    processingMessage: 'Please wait a moment, agent is processing...',
    connectAgentMessageButton: 'Personalize Email Invite with Attribute Connection Agent',
    revertStandardInstructions: 'Revert back to standard instructions',
    useAgentSuggestion: 'Use agent suggested instructions',
    messageCharacterLimit: CHARACTER_LIMIT,
    emailLimit: EMAIL_LIMIT,
    disabled: false,
  };

  state = {
    emailInfo: {},
    isProcessing: false,
    originalTemplate: null,
    currentTemplate: null,
    revertedTemplate: null,
    isModifiedByAgent: false,
    revertedOnce: false,
    agentContent: null,
    isEditingAgentContent: false, 
  };

  static getDerivedStateFromProps(props, prevState) {
    const { edit, emailInfo } = props;
    const { emailInfo: prevEmailInfo } = prevState;

    if (emailInfo) {
      return {
        emailInfo: {
          ...emailInfo,
          agentContent: prevState.emailInfo.agentContent || emailInfo.agentContent,
        },
      };
    }

    if (!edit && prevEmailInfo) {
      return { emailInfo: prevEmailInfo };
    }
    return null;
  }

  
  componentDidMount() {
    const customMessageElement = document.querySelector(
      'textarea#custom_message'
    );
    if (customMessageElement) {
      // get default value from template
      this.handleMessageChange(customMessageElement);
      
      customMessageElement.addEventListener('input', (event) => {
        this.handleMessageChange(event.target);
      });
    }
    const { emailInfo } = this.state;
    if (emailInfo && emailInfo.template && !this.state.originalTemplate) {
      const bodyContent = this.getBodyContent(emailInfo.template);
      this.setState({
        originalTemplate: bodyContent,
        revertedTemplate: bodyContent,
        currentTemplate: bodyContent,
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.advertiserUrl !== prevProps.advertiserUrl) {
      this.setState(
        (prevState) => ({
          isModifiedByAgent: false,
          revertedOnce: false,
          currentTemplate: prevState.originalTemplate,
        }),
        () => {
          const { emailInfo, originalTemplate } = this.state;
          if (originalTemplate) {
            const { agentContent, ...rest } = emailInfo;
            this.updateEmailInfo({
              ...rest,
              template: Array.isArray(originalTemplate)
                ? originalTemplate[0]
                : originalTemplate,
            });
          }
        }
      );
    }

    if (prevState.currentTemplate !== this.state.currentTemplate) {
      const customMessageElement = document.querySelector('textarea#custom_message');
      if (customMessageElement) {
        customMessageElement.removeEventListener("input", this._customMessageHandler);
        this._customMessageHandler = (event) => this.handleMessageChange(event.target);
        customMessageElement.addEventListener("input", this._customMessageHandler);
      }
    }
  }

  callAgentAPI = async () => {
    const { selectedConnectionType, advertiserUrl } = this.props;
    const { emailInfo } = this.state;
    this.setState({ isProcessing: true });
  
    try {
      const response = await fetchAgentTemplate({
        baseUrl: this.props.baseUrl,
        advertiserUrl,
        selectedConnectionType,
        originalTemplate: emailInfo.template,
      });

      const { updatedTemplate, agentContent, rawContent } = response;
      const agentHtml = marked(rawContent || '');
      const finalHtml = (updatedTemplate || '').replace(
        /<div id="agent-content">[\s\S]*$/i,
        `<div id="agent-content">${agentHtml}</div>`
      );
      const updatedEmailInfo = {
        ...this.state.emailInfo,
        agentContent: marked(rawContent || ''),
        template: Array.isArray(finalHtml) ? finalHtml[0] : finalHtml,
      };

     this.setState({
        currentTemplate: finalHtml,
        revertedTemplate: finalHtml,
        isModifiedByAgent: true,
        revertedOnce: false,
        agentContent: agentContent,
        rawContent: rawContent,
        emailInfo: updatedEmailInfo,
        urlError: '',
      }, () => {
        this.updateEmailInfo(updatedEmailInfo);
      });
    } catch (error) {
      this.props.showToast({
        message: error.message || 'Failed to fetch agent suggestion',
        action: 'Dismiss',
        type: 'Failed',
      });
    } finally {
      this.setState({ isProcessing: false });
    }
  };
  buildFinalHtml = () => {
    const { currentTemplate, rawContent } = this.state;
    const agentHtml = marked(rawContent || '');
    const finalHtml = (currentTemplate || '').replace(
      /<div id="agent-content">[\s\S]*$/i,
      `<div id="agent-content">${agentHtml}</div>`
    );
    return finalHtml;
  };

  updateEmailInfo(emailInfo) {
    const { onEmailInfoChange, validateOnChange } = this.props;
    const emailInfoToUse = validateOnChange ? validateEmailInfo(emailInfo, true) : emailInfo;
    onEmailInfoChange && onEmailInfoChange(emailInfoToUse);
  }

  handleEmailChange = () => {
    const emailValue = this.emailInputRef.current.value;
    const { emailInfo } = this.state;
    const newEmailInfo = { ...emailInfo, emailValue, emailError: '' };

    this.updateEmailInfo(newEmailInfo);
    this.setState({ emailInfo: newEmailInfo });
  };

  handleEmailKeyDown = (event) => {
    if (['Enter', 'Tab', ',', ' '].includes(event.key)) {
      const { emailInfo } = this.state;
      const { emailValue, emails } = emailInfo;
      event.preventDefault();

      const email = emailValue.trim();

      if (!email && event.key === 'Tab') {
        this.messageTextFieldRef.current.focus();
      }

      if (email && this.isValidEmail(email)) {
        const updatedEmailInfo = {
          ...emailInfo,
          emails: [...emails, email],
          emailError: '',
          emailValue: '',
        };

        this.setState({ emailInfo: updatedEmailInfo });
        this.updateEmailInfo(updatedEmailInfo);
      }
    }
  };

  handleEmailDelete = (emailToDelete) => {
    const { emailInfo: prevEmailInfo } = this.state;
    const { emails, emailValue } = prevEmailInfo;

    const filteredEmails = emails.filter((email) => email !== emailToDelete);
    const emailInfo = { ...prevEmailInfo, emails: filteredEmails };

    if (filteredEmails.length === 0 && !emailValue) {
      emailInfo.emailError = INPUT_ERROR_MESSAGE;
    }

    this.setState({ emailInfo });
    this.updateEmailInfo(emailInfo);
    this.handleEmailInputFocus();
  };

  handleMessageChange = (event) => {
    const { emailInfo } = this.state;
    const message = event.value || '';
    const updatedEmailInfo = { ...emailInfo, message, msgError: '' };
    this.setState({ emailInfo: updatedEmailInfo });
    this.updateEmailInfo(updatedEmailInfo);
  };

  isValidEmail(email) {
    const { emailLimit } = this.props;
    const { emailInfo } = this.state;
    let emailError = null;

    if (!this.isEmail(email)) {
      emailError = `${email} is not a valid email address`;
    }

    if (this.isEmailInList(email)) {
      emailError = `${email} is already in the list`;
    }

    if (this.isEmailListOverLimit()) {
      emailError = `Only ${emailLimit} emails are allowed`;
    }

    if (emailError) {
      const updatedEmailInfo = { ...emailInfo, emailError };

      this.setState({ emailInfo: updatedEmailInfo });
      this.updateEmailInfo(updatedEmailInfo);

      return false;
    }

    return true;
  }

  isEmail(email) {
    const re = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
  }

  isEmailInList(email) {
    const { emailInfo } = this.state;
    const { emails } = emailInfo;

    return !!emails.find(
      (emailInList) => emailInList.toLowerCase() === email.toLowerCase()
    );
  }

  isEmailListOverLimit() {
    const { emailLimit } = this.props;
    const { emailInfo } = this.state;
    const { emails } = emailInfo;

    return emails.length >= emailLimit;
  }

  handleEmailInputFocus = () => {
    this.emailInputRef.current.focus();
  };

  handleMessageTextFieldFocus = (event) => {
    // Move caret at the end of the input
    const value = event.target.value;
    event.target.value = '';
    event.target.value = value;
  };

  //---------------------------------------------------------------------
  //---------------------------Draw Functions----------------------------
  //---------------------------------------------------------------------
  drawDeleteIcon = () => {
    return (
      <div data-test="emailDeleteIcon" className={styles.deleteIcon}>
        <CloseIcon fontSize="inherit" />
      </div>
    );
  };

  emailInputRef = React.createRef();
  messageTextFieldRef = React.createRef();
  drawEmailInput() {
    const { disabled } = this.props;
    const { emailInfo = {} } = this.state;
    const { emailValue, emails = [] } = emailInfo;
    const deleteIcon = this.drawDeleteIcon();

    const inputWidth =
      emails.length > 0 ? `${(emailValue.length + 1) * 10}px` : '100%';

    return (
      <div
        data-test="advEmailInfo"
        className={styles.emailInput}
        onClick={this.handleEmailInputFocus}
      >
        <Fragment>
          {emails.map((email) => {
            return cloneElement(<Chip />, {
              key: email,
              label: email,
              disabled,
              deleteIcon: deleteIcon,
              onDelete: disabled ? null : () => this.handleEmailDelete(email),
            });
          })}
        </Fragment>
        <input
          data-test="advFormEmailInput"
          type="text"
          ref={this.emailInputRef}
          style={{ width: inputWidth }}
          disabled={disabled}
          onChange={this.handleEmailChange}
          onKeyDown={this.handleEmailKeyDown}
          value={emailValue || ''}
          required
          placeholder={emails.length === 0 && 'Emails'}
        />
      </div>
    );
  }

  transform = (domNode) => {
    if (domNode.attribs && domNode.attribs.id === 'agent-content') {
      const { isEditingAgentContent, emailInfo } = this.state;
  
      if (isEditingAgentContent) {
        return (
          <textarea
            style={{
              width: '100%',
              minHeight: '550px',
              outline: '2px solid transparent',
              outlineOffset: '2px',
              borderRadius: '4px',
            }}
            value={this.state.rawContent || ''}
            onChange={(e) => {
              const newContent = e.target.value;
              this.setState((prev) => ({
          ...prev,
          rawContent: newContent,
          emailInfo: {
            ...prev.emailInfo,
            agentContent: marked(newContent),
          },
              }));
            }}
            onBlur={() => {
              this.setState({ isEditingAgentContent: false }, () => {
          const finalHtml = this.buildFinalHtml();
          this.setState({ currentTemplate: finalHtml }, () => {
            this.updateEmailInfo({
              ...this.state.emailInfo,
              template: finalHtml,
            });
          });
              });
            }}
          />
        );
      }

      return (
        <div
          style={{ cursor: 'pointer' }}
          onClick={() => this.setState({ isEditingAgentContent: true })}
          dangerouslySetInnerHTML={{
            __html: marked(emailInfo.agentContent || ''),
          }}
        />
      );
    }
  };
  
  getBodyContent = (message) => {
    const m = (message || '').match(/<body[^>]*>[\s\S]*<\/body>/i);
    return m ? m[0] : (message || '');
  };

   handleRevertToOriginal = () => {
    const { originalTemplate, emailInfo } = this.state;
    this.setState({
      currentTemplate: originalTemplate,
      revertedOnce: true,
    });

    this.updateEmailInfo({
      ...emailInfo,
      agentContent: null,
      template: originalTemplate,
    });
  };
  
  handleUseAgentSuggestion = () => {
    const { revertedTemplate, emailInfo } = this.state;
    this.setState({
      currentTemplate: revertedTemplate,
      revertedOnce: false,
    });
  
    this.updateEmailInfo({
      ...emailInfo,
      agentContent: this.state.agentContent,
      template: revertedTemplate,
    });
  };


  render() {
    const {
      disabled,
      emailInputLabel,
      messageInputLabel,
      classes,
      helperText,
      title,
      selectedConnectionType,
      processingMessage,
      connectAgentMessageButton,
      revertStandardInstructions,
      useAgentSuggestion,
      isDisabled
    } = this.props;
    const { emailInfo, currentTemplate, isProcessing, isModifiedByAgent, revertedOnce } = this.state;
    const { emailError, msgError, template = '' } = emailInfo;
  
    const options = {
      replace: this.transform
    };

    return (
      <div className={classnames(classes, styles.advertiserEmailInfo)}>
        {title && <div className={styles.titleLabel}>{title}</div>}
        <div className={styles.formControl}>
          <div className={classnames(styles.invitationLabel)}>
            {emailInputLabel}
          </div>
          <div className={styles.autoFlex}>
            {this.drawEmailInput()}
            {emailError && (
              <p data-test="advEmailError" className={styles.error}>
                {emailError}
              </p>
            )}
          </div>
        </div>
        <div className={styles.messageContainer}>
          <div
            className={classnames(styles.invitationLabel, styles.marginLabel)}
          >
            {messageInputLabel}
          </div>
          <div className={styles.messageLayout}>
          <div className={styles.textMessageBox}>
            {ReactHtmlParser(currentTemplate || '', { transform: this.transform })}
          </div>
            {!disabled && msgError && (
              <p className={styles.error}>{msgError}</p>
            )}
            {(selectedConnectionType === 'ga4' || selectedConnectionType === 'pixel') && (
              <AgentButtons
                isProcessing={isProcessing}
                isModifiedByAgent={isModifiedByAgent}
                revertedOnce={revertedOnce}
                onConnectAgent={this.callAgentAPI}
                onRevertToOriginal={this.handleRevertToOriginal}
                onUseAgentSuggestion={this.handleUseAgentSuggestion}
                connectAgentMessageButton={connectAgentMessageButton}
                revertStandardInstructions={revertStandardInstructions}
                useAgentSuggestion={useAgentSuggestion}
                processingMessage={processingMessage}
                isDisabled={isDisabled}
              />
            )}
            {helperText && (
              <div className={styles.helperText}>{helperText}</div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default connect(
  null,
  dispatch => ({
    showToast: compose(dispatch, showToast)
  })
)(InvitationForm);
